// don't need more than node because node variables are internal unless referencable
import type { NodeConfig } from "../../schemas/index.ts";
import {
  extractNodeValueRefIds,
  hasNodeReferences,
  hasVariableConfigs,
  isDirectReferenceVariable,
} from "../../shared/index.ts";
import type { NodeDesignsState } from "../types.ts";

export const resolveNodeIdsWithConfigReferencesCreate =
  (designsById: NodeDesignsState["designsById"]) =>
  (toNodeId: number): number[] => {
    const containsVariableReference = (config: NodeConfig) =>
      hasVariableConfigs(config) &&
      !!Object.values(config.variables).find(
        (variable) => isDirectReferenceVariable(variable) && variable.refId.startsWith(`${toNodeId}:`),
      );

    const containsNodeReference = (config: NodeConfig) =>
      hasNodeReferences(config) && !!Object.values(config.nodeReferences).find((refNodeId) => refNodeId === toNodeId);

    const containsValueReference = (config: NodeConfig) => extractNodeValueRefIds(config).includes(toNodeId);

    return Object.entries(designsById)
      .filter(
        ([, { config }]) =>
          containsVariableReference(config) || containsNodeReference(config) || containsValueReference(config),
      )
      .flatMap(([nodeId]) => Number(nodeId));
  };

export type ResolveNodeIdsWithConfigReferences = ReturnType<typeof resolveNodeIdsWithConfigReferencesCreate>;
